import { types, } from 'mobx-state-tree';
import * as Yup from 'yup';
import { navStore } from './NavStore';
import { fieldValidator } from './YupAdapter';
import schema, { generateType, } from './Schema';
import { Item } from './ItemModel';
import { checkAccess, slugify } from './itemCommon';
const MicrocastModel = generateType(schema.getModel('microcast'))
    .views((self) => ({
    isAsset() {
        return false;
    },
    isCourse() {
        return false;
    },
    isDocument() {
        return false;
    },
    isProgram() {
        return false;
    },
    isMeeting() {
        return false;
    },
    isMicrocast() {
        return true;
    },
    itemImage() {
        return self.microcastImage;
    },
    checkAccess() {
        return checkAccess(self);
    },
}))
    .actions(() => ({}));
export const Microcast = types
    .compose(MicrocastModel, Item)
    .actions((self) => ({
    async preUpdate() {
        self.setInstuctorNames();
        if (!self.manualSlug) {
            self.slug = slugify(self.name);
        }
        const slugValidator = fieldValidator('slug', {
            type: 'string',
            validation: 'slug',
        }, false);
        try {
            slugValidator?.validateSync(self.slug, { abortEarly: false });
        }
        catch (error) {
            if (error instanceof Yup.ValidationError) {
                console.error('Validation error:', error.errors);
                navStore.errorDialog.showError('Validation Error', `slug: ${error.message}`);
            }
            throw error;
        }
    },
}))
    .named('Microcast');
export const MicrocastProgress = generateType(schema.getModel('microcastProgress') /* , overrideMap */)
    .views((self) => ({
    getItem() {
        return self.microcast;
    },
}));
export const startMicrocastGQL = (isPortalApi) => (`
  mutation StartMicrocast(
    $microcastKey: String!
    $portalID: String!
    ${!isPortalApi ? '$organizationID: String!' : ''}
  ) {
    startMicrocast(
      microcastKey: $microcastKey
      portalID: $portalID
      ${!isPortalApi ? 'organizationID: $organizationID' : ''}      
    ) {
      statusCode
      microcastProgress {
        ${schema.getGqlPropertyList('microcastProgress', isPortalApi).join(' ')}
      }
      programProgresses {
        ${schema.getGqlPropertyList('programProgress', isPortalApi).join(' ')}
      }
      message
    }
  }
`);
export const trackMicrocastProgressGQL = (isPortalApi) => (`
mutation TrackMicrocastProgress(
  $microcastKey: String
  ${!isPortalApi ? '$organizationID: String!' : ''}
  $progress: String
  $lastPosition: Int
  $maxPosition: Int
) {
  trackMicrocastProgress(
    microcastKey: $microcastKey
    ${!isPortalApi ? 'organizationID: $organizationID' : ''}      
    progress: $progress
    lastPosition: $lastPosition
    maxPosition: $maxPosition
  ) {
    statusCode
    microcastProgress {
      ${schema.getGqlPropertyList('microcastProgress', isPortalApi).join(' ')}
    }
    programProgresses {
      ${schema.getGqlPropertyList('programProgress', isPortalApi).join(' ')}
    }
  }
}`);
//# sourceMappingURL=MicrocastModel.js.map